import { FC } from 'react';

import BaseButton from 'atoms/BaseButton';

export interface Props {
  title: string;
  subtitle?: string | null;
  className?: string | null;
}

const CaseStudySkeleton: FC<Props> = ({ title, subtitle, className }) => {
  return (
    <div
      className={`CaseStudySkeleton w-full h-full fixed flex flex-col top-0 left-0 z-loading bg-white-tint text-black font-book transition duration-300 ${className}`}
    >
      <div className="bg-white-tint-gradient top-0 flex flex-row justify-between w-full p-4 desktop:px-6 desktop:py-4 items-center">
        <div className="py-1 px-2 rounded-full backdrop-blur-xl bg-white-tint-opaque -translate-x-2">
          <BaseButton
            label="All work"
            url="/work"
            isScrewIncluded={true}
            isInternal={true}
          />
        </div>
      </div>
      <div className="font-book absolute top-0 flex flex-row justify-end w-full p-4 desktop:px-6 desktop:py-4 items-center z-nav font-lighter-normal h-16">
        <span>Manhattan Hydraulics</span>
      </div>
      <div className="content-max-width font-book text-xl desktop:text-desktop-xl flex flex-col space-y-14 desktop:space-y-44 pt-20 desktop:pt-28 pb-10 w-full">
        <div className="CaseStudy__inner-wrapper CaseStudy__intro">
          <div className="flex flex-col space-y-1 mb-10 desktop:mb-10">
            <div>{title}</div>
            <div className="text-black-tint">{subtitle}</div>
          </div>
          <div className="flex flex-col space-y-8 bg-sand rounded-sm p-4 desktop:p-8 h-96"></div>
        </div>
      </div>
    </div>
  );
};

export default CaseStudySkeleton;
